import React from "react";

const Profile = () => {
  return (
    <div>
      <h1>Profile</h1>
      <p>Content of the profile page...</p>
    </div>
  );
};

export default Profile;
